var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIbanCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("title", {
    stroke: "null"
  }, "iban2"), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f4f4f4",
    transform: "translate(0.04 0.04)",
    d: "m326.87534,599.81526l-24.5836,-223.55841a21.95641,21.95641 0 0 1 0.78239,-8.81221a23.13412,23.13412 0 0 1 4.07668,-7.86511l94.25773,-117.19418a22.64821,22.64821 0 0 1 20.42457,-8.27689l266.96061,32.94285a22.56997,22.56997 0 0 1 11.24175,4.69436a22.88293,22.88293 0 0 1 7.20625,9.84168l54.80866,146.43096a22.44232,22.44232 0 0 1 1.23536,10.91232l-21.33049,160.88464l-415.07989,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m405.03225,425.09463a18.53035,18.53035 0 1 0 -18.53035,-18.53035a18.50565,18.50565 0 0 0 18.53035,18.53035z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m396.59064,401.29342a2.75073,2.75073 0 0 1 0.53532,-1.68832a2.97309,2.97309 0 0 1 1.35889,-1.11182a2.92368,2.92368 0 0 1 1.77068,-0.16471a2.98133,2.98133 0 0 1 2.38836,2.38836a3.29428,3.29428 0 0 1 -0.16471,1.77068a3.01839,3.01839 0 0 1 -1.11182,1.35889a3.15016,3.15016 0 0 1 -1.68832,0.53532a3.08427,3.08427 0 0 1 -2.18246,-0.90593a3.23663,3.23663 0 0 1 -0.90593,-2.18246z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m398.36132,412.61753l11.28293,-14.4125l0.12354,-0.12354a0.24707,0.24707 0 0 1 0.16471,-0.04118l0.16471,0a0.31296,0.31296 0 0 1 0.16471,0.08236l1.7295,1.35889a0.41179,0.41179 0 0 1 0.16471,0.28825a0.44473,0.44473 0 0 1 -0.08236,0.32943l-11.3241,14.4125a0.41179,0.41179 0 0 1 -0.28825,0.16471a0.44473,0.44473 0 0 1 -0.32943,-0.08236l-1.7295,-1.35889l-0.12354,-0.12354a0.24707,0.24707 0 0 1 -0.04118,-0.16471l0,-0.16471a0.56826,0.56826 0 0 0 0.12354,-0.16471z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m410.38546,415.04706a2.75073,2.75073 0 0 1 -1.68832,-0.53532a2.97309,2.97309 0 0 1 -1.11182,-1.35889a2.92368,2.92368 0 0 1 -0.16471,-1.77068a2.98133,2.98133 0 0 1 2.38836,-2.38836a3.29428,3.29428 0 0 1 1.77068,0.16471a3.01839,3.01839 0 0 1 1.35889,1.11182a3.10486,3.10486 0 0 1 0.49414,1.68832a3.16663,3.16663 0 0 1 -3.04721,3.08839z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m396.59064,401.29342a2.75073,2.75073 0 0 1 0.53532,-1.68832a2.97309,2.97309 0 0 1 1.35889,-1.11182a2.92368,2.92368 0 0 1 1.77068,-0.16471a2.98133,2.98133 0 0 1 2.38836,2.38836a3.29428,3.29428 0 0 1 -0.16471,1.77068a3.01839,3.01839 0 0 1 -1.11182,1.35889a3.15016,3.15016 0 0 1 -1.68832,0.53532a3.08427,3.08427 0 0 1 -2.18246,-0.90593a3.23663,3.23663 0 0 1 -0.90593,-2.18246z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m398.36132,412.61753l11.28293,-14.4125l0.12354,-0.12354a0.24707,0.24707 0 0 1 0.16471,-0.04118l0.16471,0a0.31296,0.31296 0 0 1 0.16471,0.08236l1.7295,1.35889a0.41179,0.41179 0 0 1 0.16471,0.28825a0.44473,0.44473 0 0 1 -0.08236,0.32943l-11.3241,14.4125a0.41179,0.41179 0 0 1 -0.28825,0.16471a0.44473,0.44473 0 0 1 -0.32943,-0.08236l-1.7295,-1.35889l-0.12354,-0.12354a0.24707,0.24707 0 0 1 -0.04118,-0.16471l0,-0.16471a0.56826,0.56826 0 0 0 0.12354,-0.16471z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m410.38546,415.04706a2.75073,2.75073 0 0 1 -1.68832,-0.53532a2.97309,2.97309 0 0 1 -1.11182,-1.35889a2.92368,2.92368 0 0 1 -0.16471,-1.77068a2.98133,2.98133 0 0 1 2.38836,-2.38836a3.29428,3.29428 0 0 1 1.77068,0.16471a3.01839,3.01839 0 0 1 1.35889,1.11182a3.10486,3.10486 0 0 1 0.49414,1.68832a3.16663,3.16663 0 0 1 -3.04721,3.08839z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m388.68436,349.32608a18.53035,18.53035 0 1 0 -18.53035,-18.53035a18.50565,18.50565 0 0 0 18.53035,18.53035z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m398.60839,324.45423a0.56826,0.56826 0 0 0 -0.16471,-0.12354a0.24707,0.24707 0 0 0 -0.16471,-0.04118l-15.89492,0l-0.45296,-2.18246c0,-0.08236 -0.08236,-0.16471 -0.16471,-0.24707a0.58474,0.58474 0 0 0 -0.24707,-0.08236l-2.51189,0a0.41179,0.41179 0 0 0 0,0.82357l2.14129,0l2.05893,10.21228a2.80426,2.80426 0 0 0 1.02946,1.68832a3.08427,3.08427 0 0 0 1.85304,0.65886l9.63578,0a0.41179,0.41179 0 0 0 0,-0.82357l-9.55343,0a1.9148,1.9148 0 0 1 -0.94711,-0.24707a2.25659,2.25659 0 0 1 -0.74121,-0.65886l12.23003,-1.64714a0.31296,0.31296 0 0 0 0.20589,-0.08236a0.22648,0.22648 0 0 0 0.12354,-0.20589l1.68832,-6.71211l0,-0.16471c-0.04118,-0.04118 -0.08236,-0.12354 -0.12354,-0.16471z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m394.44936,340.14326a2.09187,2.09187 0 0 0 1.7295,-2.38836a2.08364,2.08364 0 1 0 -4.11786,0.65886a2.05893,2.05893 0 0 0 2.38836,1.7295z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m385.76068,340.18444a2.10011,2.10011 0 1 0 -2.10011,-2.10011a2.08364,2.08364 0 0 0 2.10011,2.10011z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m398.60839,324.45423a0.56826,0.56826 0 0 0 -0.16471,-0.12354a0.24707,0.24707 0 0 0 -0.16471,-0.04118l-15.89492,0l-0.45296,-2.18246c0,-0.08236 -0.08236,-0.16471 -0.16471,-0.24707a0.58474,0.58474 0 0 0 -0.24707,-0.08236l-2.51189,0a0.41179,0.41179 0 0 0 0,0.82357l2.14129,0l2.05893,10.21228a2.80426,2.80426 0 0 0 1.02946,1.68832a3.08427,3.08427 0 0 0 1.85304,0.65886l9.63578,0a0.41179,0.41179 0 0 0 0,-0.82357l-9.55343,0a1.9148,1.9148 0 0 1 -0.94711,-0.24707a2.25659,2.25659 0 0 1 -0.74121,-0.65886l12.23003,-1.64714a0.31296,0.31296 0 0 0 0.20589,-0.08236a0.22648,0.22648 0 0 0 0.12354,-0.20589l1.68832,-6.71211l0,-0.16471c-0.04118,-0.04118 -0.08236,-0.12354 -0.12354,-0.16471z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m394.44936,340.14326a2.08364,2.08364 0 1 0 -2.38836,-1.7295a2.05893,2.05893 0 0 0 2.38836,1.7295z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m385.76068,340.18444a2.10011,2.10011 0 1 0 -2.10011,-2.10011a2.08364,2.08364 0 0 0 2.10011,2.10011z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(0.04 0.04)",
    d: "m750.47919,600.63883l-432.58078,0a0.58474,0.58474 0 0 1 -0.24707,-0.08236c-0.08236,-0.04118 -0.08236,-0.12354 -0.08236,-0.24707a0.31296,0.31296 0 0 1 0.08236,-0.20589c0.04118,-0.08236 0.12354,-0.08236 0.24707,-0.08236l432.58078,0a0.58474,0.58474 0 0 1 0.24707,0.08236c0.08236,0.04118 0.08236,0.12354 0.08236,0.20589a0.58474,0.58474 0 0 1 -0.08236,0.24707a0.3006,0.3006 0 0 1 -0.24707,0.08236z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m489.40712,292.95263a18.53035,18.53035 0 1 0 -18.53035,-18.53035a18.50565,18.50565 0 0 0 18.53035,18.53035z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m484.13626,271.62213l1.81186,0l3.54136,-5.31203l0.28825,-2.96486a0.59709,0.59709 0 0 1 0.08236,-0.28825a0.41179,0.41179 0 0 1 0.24707,-0.20589a0.7618,0.7618 0 0 1 0.28825,-0.08236a0.90593,0.90593 0 0 1 0.32943,0.04118c0.78239,0.37061 1.56479,1.40007 1.56479,4.32375c0,3.29428 0.04118,3.50018 0.04118,3.50018l5.51793,0.04118a1.2683,1.2683 0 0 1 1.23536,1.23536c0.04118,2.10011 0.12354,6.3415 0.16471,8.6475a3.29428,3.29428 0 0 1 -0.61768,2.14129a3.65254,3.65254 0 0 1 -1.81186,1.31771a3.17898,3.17898 0 0 1 -0.61768,0.08236c-1.48243,0 -8.97693,-1.19418 -8.97693,-1.19418l-3.08839,0l0,-11.28293z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m478.94776,271.62213l1.153,11.44764l3.08839,0l0,-11.44764l-4.24139,0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m484.13626,271.62213l1.81186,0l3.54136,-5.31203l0.28825,-2.96486a0.59709,0.59709 0 0 1 0.08236,-0.28825a0.41179,0.41179 0 0 1 0.24707,-0.20589a0.7618,0.7618 0 0 1 0.28825,-0.08236a0.90593,0.90593 0 0 1 0.32943,0.04118c0.78239,0.37061 1.56479,1.40007 1.56479,4.32375c0,3.29428 0.04118,3.50018 0.04118,3.50018l5.51793,0.04118a1.2683,1.2683 0 0 1 1.23536,1.23536c0.04118,2.10011 0.12354,6.3415 0.16471,8.6475a3.29428,3.29428 0 0 1 -0.61768,2.14129a3.65254,3.65254 0 0 1 -1.81186,1.31771a3.17898,3.17898 0 0 1 -0.61768,0.08236c-1.48243,0 -8.97693,-1.19418 -8.97693,-1.19418l-3.08839,0l0,-11.28293z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m478.94776,271.62213l1.153,11.44764l3.08839,0l0,-11.44764l-4.24139,0z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(0.04 0.04)",
    d: "m547.22182,299.08823l26.47781,0a16.17906,16.17906 0 0 1 6.05325,1.19418a15.23607,15.23607 0 0 1 5.10614,3.41782a15.67256,15.67256 0 0 1 3.41782,5.10614a15.8661,15.8661 0 0 1 1.19418,6.05325l0,269.39014a15.74668,15.74668 0 0 1 -15.77139,15.77139l-26.47781,0a5.79794,5.79794 0 0 1 -2.22364,-0.45296a5.91324,5.91324 0 0 1 -1.89421,-1.27654a6.66681,6.66681 0 0 1 -1.27654,-1.89421a5.95854,5.95854 0 0 1 -0.45296,-2.22364l0,-289.27939a5.79794,5.79794 0 0 1 0.45296,-2.22364a5.31615,5.31615 0 0 1 1.27654,-1.89421a5.58381,5.58381 0 0 1 4.11786,-1.68832z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(0.04 0.04)",
    d: "m563.52853,299.08823l-126.41818,0a16.96968,16.96968 0 0 0 -16.96557,16.96557l0,267.00179a16.96968,16.96968 0 0 0 16.96557,16.96557l126.41818,0a16.96968,16.96968 0 0 0 16.96557,-16.96557l0,-267.00179a16.96968,16.96968 0 0 0 -16.96557,-16.96557z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m563.32263,306.00623l-32.73696,0a4.59965,4.59965 0 0 0 -2.96486,1.07064a4.74789,4.74789 0 0 0 -1.60596,2.71779l0,0a4.74789,4.74789 0 0 1 -1.60596,2.71779a4.59965,4.59965 0 0 1 -2.96486,1.07064l-42.2492,0a4.59965,4.59965 0 0 1 -2.96486,-1.07064a4.74789,4.74789 0 0 1 -1.60596,-2.71779l0,0a4.74789,4.74789 0 0 0 -1.60596,-2.71779a4.59965,4.59965 0 0 0 -2.96486,-1.07064l-32.73696,0a10.49642,10.49642 0 0 0 -7.45332,3.04721a10.53759,10.53759 0 0 0 -2.26482,3.41782a10.36053,10.36053 0 0 0 -0.78239,4.0355l0,266.05468a10.49642,10.49642 0 0 0 3.04721,7.45332a10.53759,10.53759 0 0 0 3.41782,2.26482a10.36053,10.36053 0 0 0 4.0355,0.78239l126.0064,0a10.49642,10.49642 0 0 0 7.45332,-3.04721a10.11757,10.11757 0 0 0 2.26482,-3.41782a10.36053,10.36053 0 0 0 0.78239,-4.0355l0,-266.05468a10.49642,10.49642 0 0 0 -3.04721,-7.45332a10.53759,10.53759 0 0 0 -3.41782,-2.26482a11.16763,11.16763 0 0 0 -4.0355,-0.78239z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.7,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m563.32263,306.00623l-32.73696,0a4.59965,4.59965 0 0 0 -2.96486,1.07064a4.74789,4.74789 0 0 0 -1.60596,2.71779l0,0a4.74789,4.74789 0 0 1 -1.60596,2.71779a4.59965,4.59965 0 0 1 -2.96486,1.07064l-42.2492,0a4.59965,4.59965 0 0 1 -2.96486,-1.07064a4.74789,4.74789 0 0 1 -1.60596,-2.71779l0,0a4.74789,4.74789 0 0 0 -1.60596,-2.71779a4.59965,4.59965 0 0 0 -2.96486,-1.07064l-32.73696,0a10.49642,10.49642 0 0 0 -7.45332,3.04721a10.53759,10.53759 0 0 0 -2.26482,3.41782a10.36053,10.36053 0 0 0 -0.78239,4.0355l0,266.05468a10.49642,10.49642 0 0 0 3.04721,7.45332a10.53759,10.53759 0 0 0 3.41782,2.26482a10.36053,10.36053 0 0 0 4.0355,0.78239l126.0064,0a10.49642,10.49642 0 0 0 7.45332,-3.04721a10.11757,10.11757 0 0 0 2.26482,-3.41782a10.36053,10.36053 0 0 0 0.78239,-4.0355l0,-266.05468a10.49642,10.49642 0 0 0 -3.04721,-7.45332a10.53759,10.53759 0 0 0 -3.41782,-2.26482a11.16763,11.16763 0 0 0 -4.0355,-0.78239z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.5,
    transform: "translate(0.04 0.04)",
    d: "m517.20265,306.00623l-33.76642,0a1.19418,1.19418 0 1 0 0,2.38836l33.76642,0a1.19418,1.19418 0 0 0 0,-2.38836z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m563.32263,306.00623l-13.91835,34.63117l-26.80724,0l13.87717,-34.63117l26.84842,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3f4249",
    transform: "translate(0.04 0.04)",
    d: "m536.55657,306.00623l-13.91835,34.63117l-26.80724,0l13.836,-34.63117l26.8896,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m509.74933,306.00623l-13.91835,34.63117l-26.80724,0l13.836,-34.63117l26.8896,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3f4249",
    transform: "translate(0.04 0.04)",
    d: "m482.94208,306.00623l-13.91835,34.63117l-26.80724,0l13.836,-34.63117l26.8896,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m456.13484,306.00623l-13.91835,34.63117l-26.8896,0l10.87114,-27.09549a12.08179,12.08179 0 0 1 11.20057,-7.53568l18.73625,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m563.32263,306.00623l-13.91835,34.63117l-26.80724,0l13.87717,-34.63117l26.84842,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m509.74933,306.00623l-13.91835,34.63117l-26.80724,0l13.836,-34.63117l26.8896,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m456.13484,306.00623l-13.91835,34.63117l-26.8896,0l10.87114,-27.09549a12.08179,12.08179 0 0 1 11.20057,-7.53568l18.73625,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(0.04 0.04)",
    d: "m549.44546,340.6374l24.37771,0l0,-24.13064a10.54583,10.54583 0 0 0 -10.50053,-10.50053l0,0l-13.87717,34.63117z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m415.36807,340.6374l26.8896,0l0,3.50018a13.05772,13.05772 0 0 1 -1.02946,5.14732a12.53064,12.53064 0 0 1 -2.92368,4.36493a13.45715,13.45715 0 0 1 -9.51225,3.95314a13.29656,13.29656 0 0 1 -9.51225,-3.95314a13.46539,13.46539 0 0 1 -3.95314,-9.51225l0,-3.50018l0.04118,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(0.04 0.04)",
    d: "m442.17531,340.6374l26.8896,0l0,3.50018a13.29656,13.29656 0 0 1 -3.95314,9.51225a13.46539,13.46539 0 0 1 -9.51225,3.95314a13.29656,13.29656 0 0 1 -9.51225,-3.95314a13.46539,13.46539 0 0 1 -3.95314,-9.51225l0,-3.50018l0.04118,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m468.94137,340.6374l26.8896,0l0,3.50018a13.05772,13.05772 0 0 1 -1.02946,5.14732a12.53064,12.53064 0 0 1 -2.92368,4.36493a14.25602,14.25602 0 0 1 -4.36493,2.92368a13.82776,13.82776 0 0 1 -5.14732,1.02946l0,0a13.29656,13.29656 0 0 1 -9.51225,-3.95314a13.46539,13.46539 0 0 1 -3.95314,-9.51225l0,-3.50018l0.04118,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(0.04 0.04)",
    d: "m495.74862,340.6374l26.8896,0l0,3.50018a13.29656,13.29656 0 0 1 -3.95314,9.51225a13.46539,13.46539 0 0 1 -9.51225,3.95314a13.29656,13.29656 0 0 1 -9.51225,-3.95314a13.46539,13.46539 0 0 1 -3.95314,-9.51225l0,-3.50018l0.04118,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m522.55586,340.6374l26.8896,0l0,3.50018a13.29656,13.29656 0 0 1 -3.95314,9.51225a13.46539,13.46539 0 0 1 -9.51225,3.95314a13.05772,13.05772 0 0 1 -5.14732,-1.02946a12.53064,12.53064 0 0 1 -4.36493,-2.92368a14.25602,14.25602 0 0 1 -2.92368,-4.36493a13.82776,13.82776 0 0 1 -1.02946,-5.14732l0,-3.50018l0.04118,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(0.04 0.04)",
    d: "m415.36807,340.6374l26.8896,0l0,3.50018a13.05772,13.05772 0 0 1 -1.02946,5.14732a12.53064,12.53064 0 0 1 -2.92368,4.36493a13.45715,13.45715 0 0 1 -9.51225,3.95314a13.29656,13.29656 0 0 1 -9.51225,-3.95314a13.46539,13.46539 0 0 1 -3.95314,-9.51225l0,-3.50018l0.04118,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(0.04 0.04)",
    d: "m468.94137,340.6374l26.8896,0l0,3.50018a13.05772,13.05772 0 0 1 -1.02946,5.14732a12.53064,12.53064 0 0 1 -2.92368,4.36493a14.25602,14.25602 0 0 1 -4.36493,2.92368a13.82776,13.82776 0 0 1 -5.14732,1.02946l0,0a13.29656,13.29656 0 0 1 -9.51225,-3.95314a13.46539,13.46539 0 0 1 -3.95314,-9.51225l0,-3.50018l0.04118,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(0.04 0.04)",
    d: "m522.55586,340.6374l26.8896,0l0,3.50018a13.29656,13.29656 0 0 1 -3.95314,9.51225a13.46539,13.46539 0 0 1 -9.51225,3.95314a13.05772,13.05772 0 0 1 -5.14732,-1.02946a12.53064,12.53064 0 0 1 -4.36493,-2.92368a14.25602,14.25602 0 0 1 -2.92368,-4.36493a13.82776,13.82776 0 0 1 -1.02946,-5.14732l0,-3.50018l0.04118,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m535.19768,377.36868l-66.2563,0a9.66461,9.66461 0 0 0 -9.67696,9.67696l0,66.2563a9.66461,9.66461 0 0 0 9.67696,9.67696l66.2563,0a9.66461,9.66461 0 0 0 9.67696,-9.67696l0,-66.2563a9.66461,9.66461 0 0 0 -9.67696,-9.67696z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.5,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m535.19768,377.36868l-66.2563,0a9.66461,9.66461 0 0 0 -9.67696,9.67696l0,66.2563a9.66461,9.66461 0 0 0 9.67696,9.67696l66.2563,0a9.66461,9.66461 0 0 0 9.67696,-9.67696l0,-66.2563a9.66461,9.66461 0 0 0 -9.67696,-9.67696z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m531.73868,377.36868l-66.2563,0a9.66461,9.66461 0 0 0 -9.67696,9.67696l0,66.2563a9.66461,9.66461 0 0 0 9.67696,9.67696l66.2563,0a9.66461,9.66461 0 0 0 9.67696,-9.67696l0,-66.2563a9.69343,9.69343 0 0 0 -9.67696,-9.67696z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m553.23389,500.16315l-105.78772,0a2.92368,2.92368 0 0 0 0,5.84736l105.74654,0a2.93603,2.93603 0 0 0 2.92368,-2.92368a2.8825,2.8825 0 0 0 -2.8825,-2.92368z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m553.23389,482.70344l-105.78772,0a2.92368,2.92368 0 0 0 0,5.84736l105.74654,0a2.93603,2.93603 0 0 0 2.92368,-2.92368a2.8825,2.8825 0 0 0 -2.8825,-2.92368z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m534.29175,517.62286l-67.90345,0a2.92368,2.92368 0 1 0 0,5.84736l67.90345,0a2.92368,2.92368 0 0 0 0,-5.84736z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(0.04 0.04)",
    d: "m687.76424,461.4553l-47.39652,0l0,25.86014l47.39652,0l0,-25.86014z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(0.04 0.04)",
    d: "m687.76424,461.4553l-10.08875,0l0,25.86014l10.08875,0l0,-25.86014z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#868a91",
    strokeWidth: "0.37px",
    strokeMiterlimit: 10,
    fill: "none",
    transform: "translate(0.04 0.04)",
    d: "m699.17071,468.90862l-5.22968,-25.65424"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#868a91",
    strokeWidth: "0.37px",
    strokeMiterlimit: 10,
    fill: "none",
    transform: "translate(0.04 0.04)",
    d: "m700.65313,434.64806l-0.74121,33.35463"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#868a91",
    strokeWidth: "0.37px",
    strokeMiterlimit: 10,
    fill: "none",
    transform: "translate(0.04 0.04)",
    d: "m708.22999,440.82484l-7.94746,9.96521"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868a91",
    transform: "translate(0.04 0.04)",
    d: "m703.12385,475.2913l-0.78239,-1.19418a7.35037,7.35037 0 0 1 -1.19418,-4.0355l0,-2.84132l-3.04721,0l0,2.84132a7.35037,7.35037 0 0 1 -1.19418,4.0355l-0.78239,1.19418a10.72702,10.72702 0 0 0 -1.44125,8.48278l0.90593,3.50018l8.15336,0l0.90593,-3.50018a10.58701,10.58701 0 0 0 0.16471,-4.40611a11.42705,11.42705 0 0 0 -1.68832,-4.07668z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(0.04 0.04)",
    d: "m703.12385,475.2913l-0.78239,-1.19418a7.35037,7.35037 0 0 1 -1.19418,-4.0355l0,-2.84132l-0.86475,0l0,2.84132a8.9481,8.9481 0 0 0 0.98829,3.99432l0.90593,1.7295c2.22364,5.06496 -1.97657,11.48882 -1.97657,11.48882l3.50018,0l0.90593,-3.50018a10.52936,10.52936 0 0 0 -1.48243,-8.48278z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#868a91",
    strokeWidth: "0.37px",
    strokeMiterlimit: 10,
    fill: "none",
    transform: "translate(0.04 0.04)",
    d: "m697.15296,458.90223l9.47107,-7.82393"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#868a91",
    strokeWidth: "0.37px",
    strokeMiterlimit: 10,
    fill: "none",
    transform: "translate(0.04 0.04)",
    d: "m690.02907,457.13155l8.35925,7.90628"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m703.49445,446.75455l1.31771,-5.765a3.1584,3.1584 0 0 1 0.65886,-1.27654a2.8825,2.8825 0 0 1 1.19418,-0.78239a2.7219,2.7219 0 0 1 1.40007,-0.12354a2.94015,2.94015 0 0 1 1.31771,0.5765a3.0431,3.0431 0 0 1 0.86475,1.153a2.77543,2.77543 0 0 1 0.20589,1.40007a2.78779,2.78779 0 0 1 -1.56479,2.22364l-5.39439,2.59425z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m703.49445,446.75455l1.31771,-5.765a3.1584,3.1584 0 0 1 0.65886,-1.27654a2.8825,2.8825 0 0 1 1.19418,-0.78239a2.7219,2.7219 0 0 1 1.40007,-0.12354a2.94015,2.94015 0 0 1 1.31771,0.5765a3.0431,3.0431 0 0 1 0.86475,1.153a2.77543,2.77543 0 0 1 0.20589,1.40007a2.78779,2.78779 0 0 1 -1.56479,2.22364l-5.39439,2.59425z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m710.41245,441.68959a2.73014,2.73014 0 0 1 -0.45296,1.48243a2.76308,2.76308 0 0 1 -1.153,1.02946l-5.31203,2.55307l5.84736,-7.37096a2.74661,2.74661 0 0 1 0.78239,1.02946a2.41306,2.41306 0 0 1 0.28825,1.27654z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m700.48842,444.20148l-3.74725,-7.78275a3.94491,3.94491 0 0 1 -0.41179,-2.05893a4.11786,4.11786 0 0 1 0.61768,-1.97657a3.93667,3.93667 0 0 1 1.52361,-1.44125a4.34022,4.34022 0 0 1 2.01775,-0.53532l0,0a4.24139,4.24139 0 0 1 3.54136,1.97657a4.27845,4.27845 0 0 1 0.61768,1.97657a4.02315,4.02315 0 0 1 -0.41179,2.05893l-3.74725,7.78275z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m700.48842,444.20148l-3.74725,-7.78275a3.94491,3.94491 0 0 1 -0.41179,-2.05893a4.11786,4.11786 0 0 1 0.61768,-1.97657a3.93667,3.93667 0 0 1 1.52361,-1.44125a4.34022,4.34022 0 0 1 2.01775,-0.53532l0,0a4.24139,4.24139 0 0 1 3.54136,1.97657a4.27845,4.27845 0 0 1 0.61768,1.97657a4.02315,4.02315 0 0 1 -0.41179,2.05893l-3.74725,7.78275z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m700.65313,430.44784l-0.16471,13.75364l3.74725,-7.78275a4.16727,4.16727 0 0 0 0.41179,-1.97657a4.42258,4.42258 0 0 0 -0.5765,-1.93539a4.80966,4.80966 0 0 0 -1.44125,-1.44125a4.27845,4.27845 0 0 0 -1.97657,-0.61768z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m696.28821,454.57848l-5.47675,-6.50621a4.05197,4.05197 0 0 1 -0.78239,-3.91196a4.16315,4.16315 0 0 1 2.92368,-2.71779a4.34846,4.34846 0 0 1 2.05893,0a4.04373,4.04373 0 0 1 2.84132,2.71779a4.34434,4.34434 0 0 1 0.12354,2.05893l-1.68832,8.35925z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m698.01771,446.21923a3.87902,3.87902 0 0 0 -0.12354,-2.05893a3.96961,3.96961 0 0 0 -1.07064,-1.7295a3.7349,3.7349 0 0 0 -1.81186,-0.98829a4.35257,4.35257 0 0 0 -2.05893,0l3.33546,13.09478l1.7295,-8.31807z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m695.50581,462.32005l-2.47071,-6.21796a3.70607,3.70607 0 0 0 -0.94711,-1.31771a3.79255,3.79255 0 0 0 -1.48243,-0.70004a3.51253,3.51253 0 0 0 -1.60596,0.12354a3.34782,3.34782 0 0 0 -1.35889,0.86475l0,0a3.22016,3.22016 0 0 0 -0.74121,1.44125a3.22428,3.22428 0 0 0 0.86475,3.00603a2.70955,2.70955 0 0 0 1.40007,0.82357l6.3415,1.97657z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m695.50581,462.32005l-2.47071,-6.21796a3.70607,3.70607 0 0 0 -0.94711,-1.31771a3.79255,3.79255 0 0 0 -1.48243,-0.70004a3.51253,3.51253 0 0 0 -1.60596,0.12354a3.34782,3.34782 0 0 0 -1.35889,0.86475l0,0a3.22016,3.22016 0 0 0 -0.74121,1.44125a3.22428,3.22428 0 0 0 0.86475,3.00603a2.70955,2.70955 0 0 0 1.40007,0.82357l6.3415,1.97657z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m687.76424,454.99026l7.78275,7.32978l-2.47071,-6.21796a3.24487,3.24487 0 0 0 -0.94711,-1.27654a3.62371,3.62371 0 0 0 -1.44125,-0.70004a2.8825,2.8825 0 0 0 -1.56479,0.08236a2.82073,2.82073 0 0 0 -1.35889,0.78239z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m699.66485,456.88448l2.71779,-6.58857a3.07604,3.07604 0 0 1 1.02946,-1.35889a3.1831,3.1831 0 0 1 1.56479,-0.70004a4.11786,4.11786 0 0 1 1.7295,0.12354a4.17551,4.17551 0 0 1 1.44125,0.94711l0,0a3.59077,3.59077 0 0 1 0.78239,1.52361a3.51665,3.51665 0 0 1 -0.04118,1.7295a3.37252,3.37252 0 0 1 -2.34718,2.34718l-6.87682,1.97657z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m699.66485,456.88448l2.71779,-6.58857a3.07604,3.07604 0 0 1 1.02946,-1.35889a3.1831,3.1831 0 0 1 1.56479,-0.70004a4.11786,4.11786 0 0 1 1.7295,0.12354a4.17551,4.17551 0 0 1 1.44125,0.94711l0,0a3.59077,3.59077 0 0 1 0.78239,1.52361a3.51665,3.51665 0 0 1 -0.04118,1.7295a3.37252,3.37252 0 0 1 -2.34718,2.34718l-6.87682,1.97657z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#868a91",
    strokeWidth: "0.37px",
    strokeMiterlimit: 10,
    fill: "none",
    transform: "translate(0.04 0.04)",
    d: "m699.9531,464.87312l12.93007,-7.08271"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m702.05321,463.72012l4.69436,-6.42386a3.9202,3.9202 0 0 1 1.48243,-1.23536a3.31899,3.31899 0 0 1 1.89421,-0.32943a3.53724,3.53724 0 0 1 1.81186,0.61768a4.28669,4.28669 0 0 1 1.31771,1.40007a4.11786,4.11786 0 0 1 0.45296,1.85304a3.67313,3.67313 0 0 1 -0.49414,1.85304a3.85843,3.85843 0 0 1 -3.21193,1.89421l-7.94746,0.37061z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m702.05321,463.72012l4.69436,-6.42386a3.9202,3.9202 0 0 1 1.48243,-1.23536a3.31899,3.31899 0 0 1 1.89421,-0.32943a3.53724,3.53724 0 0 1 1.81186,0.61768a4.28669,4.28669 0 0 1 1.31771,1.40007a4.11786,4.11786 0 0 1 0.45296,1.85304a3.67313,3.67313 0 0 1 -0.49414,1.85304a3.85843,3.85843 0 0 1 -3.21193,1.89421l-7.94746,0.37061z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m713.33613,461.12587a3.66489,3.66489 0 0 1 -1.35889,1.60596a3.77607,3.77607 0 0 1 -1.97657,0.65886l-7.94746,0.32943l11.15939,-5.92971a3.78843,3.78843 0 0 1 0.45296,1.64714a3.44665,3.44665 0 0 1 -0.32943,1.68832z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m702.42381,450.29591l-2.71779,6.58857l8.4416,-7.53568a3.529,3.529 0 0 0 -1.44125,-0.94711a3.39723,3.39723 0 0 0 -1.68832,-0.16471a3.1831,3.1831 0 0 0 -1.56479,0.70004a3.32311,3.32311 0 0 0 -1.02946,1.35889z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(0.04 0.04)",
    d: "m707.57113,490.0744l27.63081,0a1.51949,1.51949 0 0 0 0.98829,-0.41179a1.43713,1.43713 0 0 0 0.41179,-0.98829l0,0a1.2683,1.2683 0 0 0 -0.12354,-0.53532a1.70067,1.70067 0 0 0 -0.28825,-0.45296a1.06652,1.06652 0 0 0 -0.45296,-0.28825a1.14065,1.14065 0 0 0 -0.53532,-0.12354l-27.63081,0l0,2.80014z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(0.04 0.04)",
    d: "m731.61941,488.71551l-27.87789,0l0,85.8573l27.87789,0l0,-85.8573z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#dadddf",
    transform: "translate(0.04 0.04)",
    d: "m704.5651,488.71551l-93.47533,0l0,85.8573l93.51651,0l0,-85.8573l-0.04118,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(0.04 0.04)",
    d: "m700.24135,568.02541l-85.19844,0l0,-67.36813l85.19844,0.08236l0,67.28577zm-84.53959,-0.61768l83.96309,0l0,-66.05041l-83.96309,0l0,66.05041z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#dadddf",
    transform: "translate(0.04 0.04)",
    d: "m707.57113,487.31543l-99.65212,0a1.38772,1.38772 0 0 0 -1.40007,1.40007l0,0a1.38772,1.38772 0 0 0 1.40007,1.40007l99.6933,0a1.38772,1.38772 0 0 0 1.40007,-1.40007l0,0a1.44949,1.44949 0 0 0 -1.44125,-1.40007z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(0.04 0.04)",
    d: "m615.08408,534.54724l85.19844,0l0,-0.61768l-85.19844,0l0,0.61768z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(0.04 0.04)",
    d: "m654.36843,511.48725a2.14129,2.14129 0 1 0 -2.14129,-2.14129a2.12481,2.12481 0 0 0 2.14129,2.14129z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(0.04 0.04)",
    d: "m655.10965,509.34596a1.94363,1.94363 0 0 0 -0.41179,-1.23536a2.16187,2.16187 0 0 0 -1.02946,-0.78239a1.92304,1.92304 0 0 1 0.70004,-0.12354a2.65602,2.65602 0 0 1 0.82357,0.12354a1.72126,1.72126 0 0 1 0.74121,0.45296a2.70543,2.70543 0 0 1 0.49414,0.70004a2.14129,2.14129 0 0 1 0,1.64714a2.70543,2.70543 0 0 1 -0.49414,0.70004a1.72126,1.72126 0 0 1 -0.74121,0.45296a1.9148,1.9148 0 0 1 -0.82357,0.12354a2.09187,2.09187 0 0 1 -0.70004,-0.12354a1.93539,1.93539 0 0 0 1.02946,-0.78239a1.52772,1.52772 0 0 0 0.41179,-1.153z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(0.04 0.04)",
    d: "m654.36843,544.63599a2.14129,2.14129 0 1 0 -2.14129,-2.14129a2.12481,2.12481 0 0 0 2.14129,2.14129z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(0.04 0.04)",
    d: "m655.10965,542.49471a1.94363,1.94363 0 0 0 -0.41179,-1.23536a2.16187,2.16187 0 0 0 -1.02946,-0.78239a1.92304,1.92304 0 0 1 0.70004,-0.12354a2.65602,2.65602 0 0 1 0.82357,0.12354a1.72126,1.72126 0 0 1 0.74121,0.45296a2.70543,2.70543 0 0 1 0.49414,0.70004a2.14129,2.14129 0 0 1 0,1.64714a2.70543,2.70543 0 0 1 -0.49414,0.70004a1.72126,1.72126 0 0 1 -0.74121,0.45296a1.9148,1.9148 0 0 1 -0.82357,0.12354a2.09187,2.09187 0 0 1 -0.70004,-0.12354a1.93539,1.93539 0 0 0 1.02946,-0.78239a1.58949,1.58949 0 0 0 0.41179,-1.153z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(0.04 0.04)",
    d: "m708.9712,492.9569l-4.40611,-2.8825l-93.47533,0l0,1.31771l97.88144,1.56479z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#dadddf",
    transform: "translate(0.04 0.04)",
    d: "m726.14266,574.57281l2.14129,23.76003a1.56067,1.56067 0 0 1 0,0.61768a0.98417,0.98417 0 0 1 -0.28825,0.53532a1.42066,1.42066 0 0 1 -0.49414,0.37061a1.64714,1.64714 0 0 1 -0.61768,0.12354l0,0a1.48655,1.48655 0 0 1 -0.82357,-0.24707a1.23536,1.23536 0 0 1 -0.49414,-0.70004l-6.21796,-24.50124l6.79446,0l0,0.04118z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(0.04 0.04)",
    d: "m725.31909,588.4088l-2.59425,-0.61768l-3.33546,-13.17714l6.75328,0l2.14129,23.76003a1.26006,1.26006 0 0 1 -0.12354,0.94711a1.4536,1.4536 0 0 1 -0.70004,0.61768l-2.14129,-11.53z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#dadddf",
    transform: "translate(0.04 0.04)",
    d: "m701.84731,574.57281l2.14129,23.76003a1.56067,1.56067 0 0 1 0,0.61768a0.98417,0.98417 0 0 1 -0.28825,0.53532a1.12417,1.12417 0 0 1 -0.49414,0.37061a1.64714,1.64714 0 0 1 -0.61768,0.12354l0,0a1.48655,1.48655 0 0 1 -0.82357,-0.24707a1.23536,1.23536 0 0 1 -0.49414,-0.70004l-6.21796,-24.50124l6.79446,0l0,0.04118z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(0.04 0.04)",
    d: "m699.58249,577.20823l-3.87078,-0.74121l-0.65886,-1.89421l6.75328,0l2.14129,23.76003a1.49066,1.49066 0 0 1 -0.12354,0.94711a1.4536,1.4536 0 0 1 -0.70004,0.61768l-3.54136,-22.68939z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#dadddf",
    transform: "translate(0.04 0.04)",
    d: "m640.16183,574.57281l-2.14129,23.76003a1.56067,1.56067 0 0 0 0,0.61768a0.98417,0.98417 0 0 0 0.28825,0.53532a1.12417,1.12417 0 0 0 0.49414,0.37061a1.3136,1.3136 0 0 0 0.5765,0.12354l0,0a1.48655,1.48655 0 0 0 0.82357,-0.24707a1.23536,1.23536 0 0 0 0.49414,-0.70004l6.21796,-24.50124l-6.75328,0l0,0.04118z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(0.04 0.04)",
    d: "m641.35601,587.21462l-2.306,-0.5765l1.11182,-12.06532l6.75328,0l-6.21796,24.50124a1.4536,1.4536 0 0 1 -0.49414,0.70004a1.48655,1.48655 0 0 1 -0.82357,0.24707l-0.04118,0l2.01775,-12.80653z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#dadddf",
    transform: "translate(0.04 0.04)",
    d: "m615.2488,574.57281l-2.14129,23.76003a1.56067,1.56067 0 0 0 0,0.61768a0.98417,0.98417 0 0 0 0.28825,0.53532a1.12417,1.12417 0 0 0 0.49414,0.37061a1.64714,1.64714 0 0 0 0.61768,0.12354l0,0a1.48655,1.48655 0 0 0 0.82357,-0.24707a1.23536,1.23536 0 0 0 0.49414,-0.70004l6.21796,-24.50124l-6.79446,0l0,0.04118z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(0.04 0.04)",
    d: "m617.88423,576.67291l-2.96486,-0.53532l0.32943,-1.52361l6.75328,0l-6.21796,24.50124a1.4536,1.4536 0 0 1 -0.49414,0.70004a1.48655,1.48655 0 0 1 -0.82357,0.24707l-0.08236,0l3.50018,-23.38942z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(0.04 0.04)",
    d: "m549.44546,340.6374l0,4.73553a12.0159,12.0159 0 0 0 3.58253,8.60632a12.16003,12.16003 0 0 0 8.60632,3.58253l0,0a12.0159,12.0159 0 0 0 8.60632,-3.58253a12.16003,12.16003 0 0 0 3.58253,-8.60632l0,-4.73553l-24.37771,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(0.04 0.04)",
    d: "m549.44546,340.6374l0,4.73553a12.0159,12.0159 0 0 0 3.58253,8.60632a12.16003,12.16003 0 0 0 8.60632,3.58253l0,0a12.0159,12.0159 0 0 0 8.60632,-3.58253a12.16003,12.16003 0 0 0 3.58253,-8.60632l0,-4.73553l-24.37771,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(0.04 0.04)",
    d: "m573.78199,315.43612a1.5442,1.5442 0 0 0 0.04118,0.41179a1.5442,1.5442 0 0 1 -0.04118,-0.41179z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(0.04 0.04)",
    d: "m563.36381,306.00623l-126.08875,0a12.25474,12.25474 0 0 0 -5.64146,1.48243a11.94178,11.94178 0 0 0 -4.28257,3.95314c1.27654,-0.86475 3.04721,-0.74121 5.14732,-0.74121l133.62443,0c3.82961,0 7.20625,0.98829 7.61803,4.69436a10.32347,10.32347 0 0 0 -3.41782,-6.71211a10.48406,10.48406 0 0 0 -6.95918,-2.67661z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(0.04 0.04)",
    d: "m439.00456,524.87028l-18.85978,38.70785l-0.08236,-44.96699l18.94214,6.25914z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(0.04 0.04)",
    d: "m386.21364,474.05594l-72.63898,72.63898a4.87142,4.87142 0 0 0 0,6.87682l45.04935,45.04935a4.87142,4.87142 0 0 0 6.87682,0l72.63898,-72.63898a4.87142,4.87142 0 0 0 0,-6.87682l-45.00817,-45.04935a4.84672,4.84672 0 0 0 -6.918,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m388.602,482.12694l-14.53603,14.53603a1.54008,1.54008 0 0 0 0,2.14129l2.55307,2.55307a1.54008,1.54008 0 0 0 2.14129,0l14.53603,-14.53603a1.54008,1.54008 0 0 0 0,-2.14129l-2.55307,-2.55307a1.47007,1.47007 0 0 0 -2.14129,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m345.85865,546.03606l-12.51828,12.51828l2.8825,2.8825l12.51828,-12.51828l-2.8825,-2.8825z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m338.32298,546.94199l-7.37096,7.37096a1.39595,1.39595 0 0 0 0,1.89421l1.97657,1.93539l8.31807,-8.31807l-2.92368,-2.8825z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m341.61726,543.68888l-2.84132,2.8825l2.8825,2.8825l3.78843,-3.78843l-1.97657,-1.93539a1.30536,1.30536 0 0 0 -0.94711,-0.37061a0.98005,0.98005 0 0 0 -0.90593,0.32943z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m338.57005,563.8252a1.39595,1.39595 0 0 0 1.89421,0l3.17075,-3.17075l-2.8825,-2.8825l-4.07668,4.07668l1.89421,1.97657z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m344.00562,560.24267l7.08271,-7.08271a2.49954,2.49954 0 0 0 0.28825,-0.41179a1.04594,1.04594 0 0 0 0.08236,-0.49414a2.05893,2.05893 0 0 0 -0.08236,-0.49414a1.47831,1.47831 0 0 0 -0.28825,-0.41179l-1.93539,-1.97657l-8.02982,8.02982l2.8825,2.84132z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m359.52994,556.78367l-13.46539,13.46539a0.77004,0.77004 0 0 0 0,1.07064l2.84132,2.84132a0.77004,0.77004 0 0 0 1.07064,0l13.46539,-13.46539a0.77004,0.77004 0 0 0 0,-1.07064l-2.84132,-2.84132a0.77004,0.77004 0 0 0 -1.07064,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m376.28961,540.06517l-13.46539,13.46539a0.77004,0.77004 0 0 0 0,1.07064l2.84132,2.84132a0.77004,0.77004 0 0 0 1.07064,0l13.46539,-13.46539a0.77004,0.77004 0 0 0 0,-1.07064l-2.84132,-2.84132a0.70415,0.70415 0 0 0 -1.07064,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m393.04929,523.3055l-13.46539,13.46539a0.77004,0.77004 0 0 0 0,1.07064l2.84132,2.84132a0.77004,0.77004 0 0 0 1.07064,0l13.46539,-13.46539a0.77004,0.77004 0 0 0 0,-1.07064l-2.84132,-2.84132a0.77004,0.77004 0 0 0 -1.07064,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m409.80896,506.54582l-13.46539,13.46539a0.77004,0.77004 0 0 0 0,1.07064l2.84132,2.84132a0.77004,0.77004 0 0 0 1.07064,0l13.46539,-13.46539a0.77004,0.77004 0 0 0 0,-1.07064l-2.84132,-2.84132a0.77004,0.77004 0 0 0 -1.07064,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m383.16643,558.22492l-24.62478,24.62478a1.13653,1.13653 0 0 0 1.60596,1.60596l24.62478,-24.62478a1.13653,1.13653 0 0 0 -1.60596,-1.60596z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.7,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m388.602,482.12694l-14.53603,14.53603a1.54008,1.54008 0 0 0 0,2.14129l2.55307,2.55307a1.54008,1.54008 0 0 0 2.14129,0l14.53603,-14.53603a1.54008,1.54008 0 0 0 0,-2.14129l-2.55307,-2.55307a1.47007,1.47007 0 0 0 -2.14129,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.7,
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m383.16643,558.22492l-24.62478,24.62478a1.13653,1.13653 0 0 0 1.60596,1.60596l24.62478,-24.62478a1.13653,1.13653 0 0 0 -1.60596,-1.60596z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m426.40392,519.76414a6.20149,6.20149 0 1 0 0,8.77103a6.17678,6.17678 0 0 0 0,-8.77103z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m420.51539,525.69385a6.20149,6.20149 0 1 0 0,8.77103a6.17678,6.17678 0 0 0 0,-8.77103z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f59a9c",
    transform: "translate(0.04 0.04)",
    d: "m686.03474,577.0847l0,14.57721l-11.44764,0l-1.64714,-13.75364l-0.08236,-0.82357l13.17714,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m686.03474,577.0847l0,3.70607l-4.81789,0.45296a3.29428,3.29428 0 0 0 -1.85304,0.78239a3.57842,3.57842 0 0 0 -1.11182,1.68832l-3.50018,7.90628l-0.16471,0l-1.64714,-13.75364c1.77068,-0.5765 13.09478,-0.78239 13.09478,-0.78239z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m684.79939,584.90862l-0.32943,-0.32943a6.76152,6.76152 0 0 0 -9.51225,0.12354l-0.20589,0.24707a3.47135,3.47135 0 0 0 -0.98829,2.38836l0,1.40007a7.20213,7.20213 0 0 1 -0.37061,2.47071l-1.19418,3.91196a10.07639,10.07639 0 0 0 -0.45296,2.92368l0,0.45296a1.3136,1.3136 0 0 0 0.45296,0.98829a1.29712,1.29712 0 0 0 0.98829,0.37061l13.58893,0a2.08775,2.08775 0 0 0 0.53532,-0.08236a3.07192,3.07192 0 0 0 0.49414,-0.28825a1.82833,1.82833 0 0 0 0.32943,-0.45296a1.2683,1.2683 0 0 0 0.12354,-0.53532l0,-0.20589a10.38523,10.38523 0 0 0 -0.5765,-3.37664l-1.35889,-3.82961a8.74633,8.74633 0 0 1 -0.45296,-2.71779l-0.04118,-1.07064a3.43841,3.43841 0 0 0 -1.02946,-2.38836z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(0.04 0.04)",
    d: "m686.77596,599.27994l-13.58893,0a1.52361,1.52361 0 0 1 -0.86475,-0.24707a1.39184,1.39184 0 0 1 -0.53532,-0.74121a6.08207,6.08207 0 0 0 -0.04118,0.86475l0,0.45296a1.23536,1.23536 0 0 0 0.45296,0.94711a1.47419,1.47419 0 0 0 0.98829,0.37061l13.58893,0a1.23536,1.23536 0 0 0 0.53532,-0.08236a1.06652,1.06652 0 0 0 0.45296,-0.28825a1.82833,1.82833 0 0 0 0.32943,-0.45296a1.14065,1.14065 0 0 0 0.12354,-0.53532l0,-0.16471a9.36812,9.36812 0 0 0 -0.08236,-1.07064a1.52772,1.52772 0 0 1 -0.53532,0.70004a1.30536,1.30536 0 0 1 -0.82357,0.24707z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m675.946,587.91466a0.47767,0.47767 0 0 0 0.49414,-0.49414a0.49414,0.49414 0 1 0 -0.98829,0a0.47767,0.47767 0 0 0 0.49414,0.49414z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m676.23425,589.97359a0.49414,0.49414 0 1 0 -0.49414,-0.49414a0.50238,0.50238 0 0 0 0.49414,0.49414z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m676.8931,591.95016a0.49414,0.49414 0 1 0 -0.49414,-0.49414a0.5312,0.5312 0 0 0 0.49414,0.49414z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m677.01664,594.33851a0.49414,0.49414 0 1 0 -0.49414,-0.49414a0.47355,0.47355 0 0 0 0.49414,0.49414z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m677.26371,596.39744a0.49414,0.49414 0 1 0 -0.49414,-0.49414a0.45296,0.45296 0 0 0 0.49414,0.49414z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m683.68757,595.94448a0.47767,0.47767 0 0 0 0.49414,-0.49414a0.49414,0.49414 0 0 0 -0.98829,0a0.47767,0.47767 0 0 0 0.49414,0.49414z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m683.48167,594.00909a0.49414,0.49414 0 1 0 0,-0.98829a0.47767,0.47767 0 0 0 -0.49414,0.49414a0.45296,0.45296 0 0 0 0.49414,0.49414z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m683.19342,591.45602a0.47767,0.47767 0 0 0 0.49414,-0.49414a0.49414,0.49414 0 1 0 -0.49414,0.49414z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m682.53457,589.47944a0.49414,0.49414 0 1 0 -0.49414,-0.49414a0.50238,0.50238 0 0 0 0.49414,0.49414z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m682.45221,587.54405a0.49414,0.49414 0 0 0 0,-0.98829a0.49414,0.49414 0 0 0 0,0.98829z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    fill: "none",
    transform: "translate(0.04 0.04)",
    d: "m676.15189,587.33816s2.306,-2.47071 6.30032,-0.41179"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    fill: "none",
    transform: "translate(0.04 0.04)",
    d: "m676.23425,589.31473s2.306,-2.47071 6.30032,-0.41179"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    fill: "none",
    transform: "translate(0.04 0.04)",
    d: "m676.8931,591.33248c0.53532,-0.53532 3.37664,-1.93539 6.30032,-0.41179"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    fill: "none",
    transform: "translate(0.04 0.04)",
    d: "m677.18135,593.76201s2.306,-2.47071 6.30032,-0.41179"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    fill: "none",
    transform: "translate(0.04 0.04)",
    d: "m677.26371,595.77976s2.306,-2.47071 6.30032,-0.41179"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f59a9c",
    transform: "translate(0.04 0.04)",
    d: "m642.59136,577.82591l-0.08236,0.98829l-0.04118,0.53532l-1.153,13.13596l-21.74228,0.45296l6.25914,-4.40611a5.79382,5.79382 0 0 0 1.40007,-1.60596a7.90628,7.90628 0 0 0 1.31771,-3.41782l0.86475,-5.55911l0.04118,-0.16471l13.13596,0.04118z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m642.50901,578.77302l-0.04118,0.53532l-8.11218,1.56479a4.18786,4.18786 0 0 0 -2.26482,1.27654a3.9902,3.9902 0 0 0 -0.98829,2.38836l-0.16471,2.8825l-3.70607,-0.53532a7.90628,7.90628 0 0 0 1.31771,-3.41782l0.86475,-5.55911l13.09478,0.86475z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(0.04 0.04)",
    d: "m642.63254,598.12694l-35.94888,0.08236a2.32247,2.32247 0 0 1 -0.16471,-0.49414a5.79794,5.79794 0 0 0 -0.04118,1.19418a1.38772,1.38772 0 0 0 0.37061,0.82357a1.33007,1.33007 0 0 0 0.86475,0.32943l33.72524,-0.08236a1.33007,1.33007 0 0 0 0.86475,-0.32943a1.0377,1.0377 0 0 0 0.37061,-0.82357l-0.04118,-0.70004z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m608.66023,594.33851c6.42386,-2.67661 11.61235,-4.90025 16.38907,-8.89457a6.58857,6.58857 0 0 1 3.82961,-1.56479l12.88889,-1.02946a1.81186,1.81186 0 0 1 0.65886,0.08236a1.72538,1.72538 0 0 1 0.5765,0.37061a1.5689,1.5689 0 0 1 0.37061,0.53532a1.70891,1.70891 0 0 1 0.12354,0.65886l-0.86475,13.67128l-35.94888,0.08236c-0.74121,-1.52361 0.82357,-3.459 1.97657,-3.91196z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m614.91937,594.95619a0.61768,0.61768 0 1 0 -0.65886,-0.61768a0.67121,0.67121 0 0 0 0.65886,0.61768z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m618.87251,593.92673a0.61768,0.61768 0 1 0 -0.65886,-0.61768a0.64239,0.64239 0 0 0 0.65886,0.61768z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m622.12562,591.78544a0.61768,0.61768 0 1 0 0,-1.23536a0.61768,0.61768 0 0 0 -0.65886,0.61768a0.64239,0.64239 0 0 0 0.65886,0.61768z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m625.29637,589.64416a0.61768,0.61768 0 1 0 0,-1.23536a0.61768,0.61768 0 0 0 -0.65886,0.61768a0.67121,0.67121 0 0 0 0.65886,0.61768z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m628.13769,587.00873a0.61768,0.61768 0 0 0 0.65886,-0.61768a0.65886,0.65886 0 1 0 -0.65886,0.61768z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m613.68401,592.89726l0.45296,1.11182a0.82357,0.82357 0 0 0 0.32943,0.32943a0.52709,0.52709 0 0 0 0.49414,0l0,0a0.90181,0.90181 0 0 0 0.20589,-0.12354a0.35002,0.35002 0 0 0 0.12354,-0.20589a0.52297,0.52297 0 0 0 0.04118,-0.24707a0.58474,0.58474 0 0 0 -0.08236,-0.24707l-0.61768,-1.07064l-0.94711,0.45296z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m617.18419,591.33248l0.82357,1.68832a0.56415,0.56415 0 0 0 0.41179,0.32943a0.68768,0.68768 0 0 0 0.49414,-0.04118l0,0c0.08236,-0.04118 0.12354,-0.08236 0.20589,-0.12354a0.90181,0.90181 0 0 0 0.12354,-0.20589a0.44885,0.44885 0 0 0 0.04118,-0.20589a0.31296,0.31296 0 0 0 -0.08236,-0.20589l-0.94711,-1.64714l-1.07064,0.41179z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m620.10787,589.64416l1.11182,1.44125a0.98005,0.98005 0 0 0 0.45296,0.24707a0.72062,0.72062 0 0 0 0.49414,-0.16471l0.04118,-0.04118a0.56826,0.56826 0 0 0 0.12354,-0.16471a0.37061,0.37061 0 0 0 0.04118,-0.20589l0,-0.20589a0.21413,0.21413 0 0 0 -0.08236,-0.16471l-1.07064,-1.35889l-1.11182,0.61768z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m622.99037,587.8323l1.44125,1.27654a0.58885,0.58885 0 0 0 0.41179,0.16471a0.47767,0.47767 0 0 0 0.41179,-0.16471l0,0a0.41179,0.41179 0 0 0 0.16471,-0.20589a0.52297,0.52297 0 0 0 0.04118,-0.24707a0.58474,0.58474 0 0 0 -0.08236,-0.24707a0.32119,0.32119 0 0 0 -0.16471,-0.16471l-1.44125,-1.02946l-0.78239,0.61768z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m625.83169,585.44395s0.82357,0.65886 1.40007,1.02946a0.82357,0.82357 0 0 0 0.45296,0.12354a0.57238,0.57238 0 0 0 0.41179,-0.20589a0.90181,0.90181 0 0 0 0.12354,-0.20589l0,-0.24707a0.22648,0.22648 0 0 0 -0.12354,-0.20589a0.35002,0.35002 0 0 0 -0.20589,-0.12354l-1.68832,-0.74121l-0.37061,0.5765z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#414042",
    transform: "translate(0.04 0.04)",
    d: "m632.42026,428.10066l-4.44728,150.26057l14.989,0.04118l12.97125,-124.97693c0.08236,-0.90593 1.60596,-1.60596 1.60596,-1.60596a1.84068,1.84068 0 0 1 1.11182,0.49414a1.64714,1.64714 0 0 1 0.49414,1.11182l12.72418,124.89457l14.53603,0l-0.45296,-150.21939l-53.53213,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m678.16964,578.32005l-12.31239,-118.8825a7.60156,7.60156 0 0 0 -2.10011,-4.52964a7.77863,7.77863 0 0 0 -4.44728,-2.306l-0.53532,-0.08236a2.05893,2.05893 0 0 1 0.37061,0.94711l12.72418,124.8534l6.30032,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m637.36169,428.10066l-4.94143,0l-4.44728,150.17821l5.27086,0l4.11786,-150.17821z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3f4249",
    transform: "translate(0.04 0.04)",
    d: "m643.25022,578.40241l-15.60667,0l0.24707,-3.25311l15.68903,0l-0.32943,3.25311z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m633.24383,578.40241l-5.60028,0l0.24707,-3.25311l5.47675,0l-0.12354,3.25311z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3f4249",
    transform: "translate(0.04 0.04)",
    d: "m686.65242,578.32005l-15.31842,0l-0.28825,-3.17075l15.64785,0l0,3.17075l-0.04118,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m678.16964,578.32005l-6.83564,0l-0.28825,-3.17075l6.918,0l0.20589,3.17075z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m692.08799,346.73183c-1.97657,-0.61768 -6.13561,54.76749 -6.13561,76.01562l0,5.35321l-53.53213,0l-2.96486,-55.46752c-1.11182,-11.85943 1.31771,-26.27192 -1.44125,-28.28967c19.35392,-8.56514 57.11466,-2.96486 64.07384,2.38836z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m632.83204,428.10066l53.12034,0l0,-1.85304l-53.65566,0l0.12354,1.85304l0.41179,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.5,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m632.83204,428.10066l53.12034,0l0,-1.85304l-53.65566,0l0.12354,1.85304l0.41179,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m632.83204,424.80638l53.12034,0l0,-1.85304l-53.65566,0l0.12354,1.85304l0.41179,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.5,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m632.83204,424.80638l53.12034,0l0,-1.85304l-53.65566,0l0.12354,1.85304l0.41179,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m632.83204,421.10031l53.12034,0l0,-1.85304l-53.65566,0l0.12354,1.85304l0.41179,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.5,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m632.83204,421.10031l53.12034,0l0,-1.85304l-53.65566,0l0.12354,1.85304l0.41179,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: "4px",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    fill: "none",
    transform: "translate(0.04 0.04)",
    d: "m650.74472,346.93772l0,24.0071"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m650.90943,369.21532a0.86475,0.86475 0 1 0 -0.86475,-0.86475a0.84416,0.84416 0 0 0 0.86475,0.86475z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: "4px",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    fill: "none",
    transform: "translate(0.04 0.04)",
    d: "m666.43375,346.69065l0,24.0071"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m666.55729,368.39175a0.86475,0.86475 0 1 0 -0.86475,-0.86475a0.84416,0.84416 0 0 0 0.86475,0.86475z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m671.95168,376.21568l16.38907,-1.35889l19.47746,25.61306l-17.91267,20.42457l4.07668,9.224l30.67803,-24.33653a7.00036,7.00036 0 0 0 1.77068,-8.85339l-28.53674,-45.74938c-2.306,-4.20021 -10.58289,-7.16507 -15.19489,-6.62975l-12.80653,8.6475l2.05893,23.01882z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m707.77703,400.51103l-19.35392,-25.53071l1.64714,-12.35357l20.79517,30.01917a3.83784,3.83784 0 0 1 0.65886,2.10011a3.60312,3.60312 0 0 1 -0.65886,2.05893l-3.08839,3.70607z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m689.86435,420.9356l4.11786,9.18282l0.94711,-0.78239l-4.24139,-9.30635l-0.82357,0.90593z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.5,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m689.86435,420.9356l4.11786,9.18282l0.94711,-0.78239l-4.24139,-9.34753l-0.82357,0.94711z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m691.22324,419.37081l4.24139,9.55343l0.98829,-0.78239l-4.40611,-9.67696l-0.82357,0.90593z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.5,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m691.22324,419.37081l4.24139,9.55343l0.98829,-0.78239l-4.40611,-9.67696l-0.82357,0.90593z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m692.54096,417.88838l4.36493,9.88285l0.98829,-0.78239l-4.57082,-10.00639l-0.78239,0.90593z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.5,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m692.54096,417.88838l4.36493,9.88285l0.98829,-0.78239l-4.57082,-10.00639l-0.78239,0.90593z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.4,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m685.70532,443.83087l-7.94746,-12.14768c1.56479,-1.56479 5.47675,-4.48846 7.94746,-3.70607c0,0.04118 0.37061,16.80085 0,15.85375z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fc9d9d",
    transform: "translate(0.04 0.04)",
    d: "m693.98221,430.11841l-4.07668,-9.224l-3.04721,3.82961a3.34782,3.34782 0 0 1 -0.78239,0.74121c-1.02946,0.70004 -3.41782,2.306 -3.41782,2.306l-3.459,3.17075l6.01207,9.55343c7.37096,-4.77671 3.62371,-6.38268 6.87682,-8.72985c0.45296,-0.37061 1.89421,-1.64714 1.89421,-1.64714z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m690.35849,421.92388l-0.41179,-1.07064l-3.54136,4.44728a34.52822,34.52822 0 0 0 -7.4945,5.88853l0.78239,1.23536l10.66525,-10.50053z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    transform: "translate(0.04 0.04)",
    d: "m658.69218,351.87915c-4.11786,-2.59425 -17.83032,-11.07703 -20.83635,-10.58289c-0.61768,-3.25311 5.14732,-1.02946 7.20625,-3.99432a5.18438,5.18438 0 0 1 2.18246,-1.81186c1.7295,-0.70004 3.08839,-0.49414 3.58253,-0.04118c6.67093,6.09443 11.11821,3.50018 18.03621,-1.02946c0.82357,-0.53532 4.11786,-0.24707 4.98261,2.59425c2.75896,4.85907 8.071,0.90593 8.071,5.72382c0,0.37061 -0.49414,0.32943 -1.23536,0.16471a11.11821,11.11821 0 0 0 -7.70039,1.11182l-11.94178,7.86511a2.05893,2.05893 0 0 1 -1.19418,0.37061a3.14604,3.14604 0 0 1 -1.153,-0.37061z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fc9d9d",
    transform: "translate(0.04 0.04)",
    d: "m553.52214,362.05025l-4.44728,-2.306l-6.09443,-0.32943a0.90593,0.90593 0 0 0 -0.32943,0.04118a0.41179,0.41179 0 0 0 -0.24707,0.20589a1.03358,1.03358 0 0 0 -0.16471,0.28825a0.88534,0.88534 0 0 0 0,0.32943l0,0a1.06652,1.06652 0 0 0 0.28825,0.45296a0.68356,0.68356 0 0 0 0.49414,0.20589l5.64146,0.86475l2.92368,2.306l-2.92368,-2.306l-5.06496,-0.28825a0.82357,0.82357 0 0 0 -0.28825,0.04118a0.41179,0.41179 0 0 0 -0.20589,0.16471a0.35414,0.35414 0 0 0 -0.12354,0.24707a0.60944,0.60944 0 0 0 -0.04118,0.28825l0,0a0.70004,0.70004 0 0 0 0.24707,0.41179a0.61768,0.61768 0 0 0 0.45296,0.16471l4.94143,0.74121l4.24139,3.29428l-4.24139,-3.29428l-3.78843,0.16471c-0.08236,0 -0.12354,0 -0.16471,0.04118l-0.12354,0.12354c-0.04118,0.04118 -0.04118,0.12354 -0.08236,0.16471l0,0.16471l0,0a0.41179,0.41179 0 0 0 0.20589,0.24707a0.44473,0.44473 0 0 0 0.28825,0.12354l4.15903,0.41179l4.11786,2.80014l0.32943,-5.765z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(0.04 0.04)",
    d: "m553.52214,362.05025l-4.44728,-2.306l-6.09443,-0.32943a0.90593,0.90593 0 0 0 -0.32943,0.04118a0.41179,0.41179 0 0 0 -0.24707,0.20589a1.03358,1.03358 0 0 0 -0.16471,0.28825a0.88534,0.88534 0 0 0 0,0.32943l0,0a1.06652,1.06652 0 0 0 0.28825,0.45296a0.68356,0.68356 0 0 0 0.49414,0.20589l5.64146,0.86475l2.92368,2.306l-2.92368,-2.306l-5.06496,-0.28825a0.82357,0.82357 0 0 0 -0.28825,0.04118a0.41179,0.41179 0 0 0 -0.20589,0.16471a0.35414,0.35414 0 0 0 -0.12354,0.24707a0.60944,0.60944 0 0 0 -0.04118,0.28825l0,0a0.70004,0.70004 0 0 0 0.24707,0.41179a0.61768,0.61768 0 0 0 0.45296,0.16471l4.94143,0.74121l4.24139,3.29428l-4.24139,-3.29428l-3.78843,0.16471c-0.08236,0 -0.12354,0 -0.16471,0.04118l-0.12354,0.12354c-0.04118,0.04118 -0.04118,0.12354 -0.08236,0.16471l0,0.16471l0,0a0.41179,0.41179 0 0 0 0.20589,0.24707a0.44473,0.44473 0 0 0 0.28825,0.12354l4.15903,0.41179l4.11786,2.80014l0.32943,-5.765z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fc9d9d",
    transform: "translate(0.04 0.04)",
    d: "m553.72803,360.36193l5.39439,6.54739a3.40135,3.40135 0 0 0 1.153,0.86475l12.55946,5.80618l-3.91196,7.65921l-11.73589,-6.05325c-2.59425,-0.20589 -4.73553,-1.81186 -6.3415,-3.74725l-0.04118,0a3.02662,3.02662 0 0 0 -0.78239,-0.65886c-1.153,-0.53532 -3.91196,-1.93539 -3.91196,-1.93539s-0.08236,-0.04118 -0.12354,-0.08236s-0.04118,-0.08236 -0.08236,-0.12354s-0.04118,-0.08236 -0.04118,-0.12354a0.15236,0.15236 0 0 1 0.04118,-0.12354a1.94775,1.94775 0 0 1 0.82357,-0.90593a1.51125,1.51125 0 0 1 1.19418,-0.12354l2.10011,0.45296c1.11182,0.20589 2.05893,-0.5765 1.93539,-1.60596l-0.78239,-4.44728a1.5689,1.5689 0 0 0 -0.12354,-0.41179a1.11182,1.11182 0 0 0 -0.28825,-0.32943l-6.50621,-4.57082a0.56826,0.56826 0 0 1 -0.16471,-0.12354a0.90181,0.90181 0 0 1 -0.12354,-0.20589a0.44885,0.44885 0 0 1 -0.04118,-0.20589a0.31296,0.31296 0 0 1 0.08236,-0.20589l0,0a0.89769,0.89769 0 0 1 0.16471,-0.20589l0.24707,-0.12354a0.70004,0.70004 0 0 1 0.28825,-0.04118a0.7618,0.7618 0 0 1 0.28825,0.08236c1.7295,0.90593 7.08271,3.74725 8.27689,4.44728c0.16471,0.20589 0.32943,0.32943 0.45296,0.49414z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(0.04 0.04)",
    d: "m558.29885,373.99204c-2.59425,-0.20589 -5.1885,-1.85304 -6.79446,-3.78843l-0.04118,0a3.22428,3.22428 0 0 0 -0.82357,-0.65886c-1.153,-0.53532 -3.91196,-1.93539 -3.91196,-1.93539a0.14412,0.14412 0 0 1 -0.08236,-0.04118a1.62244,1.62244 0 0 0 -0.74121,0.82357c0,0.04118 -0.04118,0.08236 -0.04118,0.12354a0.15236,0.15236 0 0 0 0.04118,0.12354c0,0.04118 0.04118,0.08236 0.08236,0.12354s0.08236,0.04118 0.12354,0.08236s2.80014,1.35889 3.91196,1.93539a2.39247,2.39247 0 0 1 0.78239,0.65886l0.04118,0c1.60596,1.89421 3.74725,3.50018 6.3415,3.74725l11.69471,6.05325s-3.21193,-4.20021 -6.50621,-6.3415c-1.44125,-0.98829 -3.17075,-0.94711 -4.07668,-0.90593z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m603.22466,381.98068l19.14803,-33.60171a11.0235,11.0235 0 0 1 10.45935,-5.60028l10.21228,0.74121l-8.72985,24.78949l-19.68335,31.29571a11.77295,11.77295 0 0 1 -3.12957,3.25311a11.08527,11.08527 0 0 1 -4.20021,1.7295a11.09762,11.09762 0 0 1 -8.6475,-2.05893l-4.24139,-3.21193l8.81221,-17.33617z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m569.00528,381.19828l29.81328,21.41285c5.80618,3.70607 12.27121,2.14129 18.48917,-7.32978l4.40611,-7.00036l-16.43025,-9.96521l-3.04721,5.60028l-29.44267,-10.33582l-3.78843,7.61803z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m572.83488,373.74496l-3.91196,7.4945l1.11182,0.70004l4.0355,-7.65921l-1.23536,-0.53532z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.6,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m572.83488,373.58025l-3.91196,7.61803l1.11182,0.70004l4.15903,-7.86511l-1.35889,-0.45296z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m574.64674,374.48618l-4.11786,7.82393l1.11182,0.74121l4.28257,-8.11218l-1.27654,-0.45296z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.6,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m574.81145,374.28029l-4.24139,8.02982l1.07064,0.78239l4.44728,-8.35925l-1.27654,-0.45296z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(0.04 0.04)",
    d: "m576.54095,375.18621l-4.32375,8.23571l1.153,0.70004l4.44728,-8.4416l-1.27654,-0.49414z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.6,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m576.66449,374.89796l-4.52964,8.56514l1.07064,0.78239l4.69436,-8.89457l-1.23536,-0.45296z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    transform: "translate(0.04 0.04)",
    d: "m674.46357,312.63598c-0.12354,0.65886 -0.98829,14.82428 -8.31807,20.58928l0,-16.47142l8.31807,-4.11786z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fc9d9d",
    transform: "translate(0.04 0.04)",
    d: "m670.05746,342.81987l-1.153,-17.0891l-0.24707,-3.41782c-0.5765,-13.0536 -17.62442,-2.38836 -17.62442,-2.38836s0.49414,4.52964 0.70004,9.51225a15.0137,15.0137 0 0 0 0.32943,3.04721l-1.11182,10.1711"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fc9d9d",
    transform: "translate(0.04 0.04)",
    d: "m670.05746,342.81987a1.76244,1.76244 0 0 1 -0.24707,0.90593a1.90657,1.90657 0 0 1 -0.61768,0.65886l-3.00603,2.05893l-6.38268,4.32375a0.70827,0.70827 0 0 1 -0.49414,0.08236a0.66297,0.66297 0 0 1 -0.45296,-0.20589l-5.39439,-4.69436l-1.85304,-1.60596a2.01363,2.01363 0 0 1 -0.5765,-0.74121a1.83245,1.83245 0 0 1 -0.12354,-0.94711l19.14803,0.16471z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fc9d9d",
    transform: "translate(0.04 0.04)",
    d: "m668.12207,310.32998l0.49414,11.36528s-1.27654,17.54207 -12.51828,16.01846c-12.97125,-1.68832 -6.95918,-27.05431 -6.95918,-27.05431l18.98332,-0.32943z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(0.04 0.04)",
    d: "m658.19804,338.3314a9.88285,9.88285 0 0 0 6.01207,-3.21193a0.31296,0.31296 0 0 0 0.08236,-0.16471a0.21413,0.21413 0 0 0 -0.08236,-0.16471a0.31296,0.31296 0 0 0 -0.16471,-0.08236a0.21413,0.21413 0 0 0 -0.16471,0.08236a9.60696,9.60696 0 0 1 -4.57082,2.80014l0,0c-3.50018,0.78239 -6.58857,-0.82357 -7.74157,-1.93539l-0.45296,4.07668a9.15399,9.15399 0 0 0 3.66489,0a8.59397,8.59397 0 0 0 3.41782,-1.40007z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(0.04 0.04)",
    d: "m654.90375,332.27815l0,-0.12354c0,-0.04118 0.04118,-0.08236 0.08236,-0.12354s0.08236,-0.04118 0.12354,-0.08236s0.08236,-0.04118 0.12354,0c0.49414,0.08236 0.98829,0.12354 1.52361,0.16471a0.58474,0.58474 0 0 1 0.24707,0.08236a0.3006,0.3006 0 0 1 0.08236,0.24707a0.58474,0.58474 0 0 1 -0.08236,0.24707a0.3006,0.3006 0 0 1 -0.24707,0.08236c-0.53532,-0.08236 -1.07064,-0.12354 -1.60596,-0.16471l0,0c-0.16471,-0.08236 -0.32943,-0.28825 -0.24707,-0.32943z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(0.04 0.04)",
    d: "m653.0919,330.71337c-0.04118,0 -0.08236,-0.04118 -0.12354,-0.08236s-0.04118,-0.08236 -0.08236,-0.12354l0,-0.12354a0.15236,0.15236 0 0 1 0.04118,-0.12354c0.04118,-0.04118 0.04118,-0.08236 0.08236,-0.08236s0.08236,-0.04118 0.12354,-0.08236l0.12354,0a0.15236,0.15236 0 0 1 0.12354,0.04118c3.41782,1.11182 4.81789,-0.49414 5.22968,-1.27654c0.04118,-0.04118 0.04118,-0.08236 0.08236,-0.08236a0.15236,0.15236 0 0 1 0.12354,-0.04118l0.12354,0c0.04118,0 0.08236,0.04118 0.12354,0.04118s0.08236,0.04118 0.08236,0.08236s0.04118,0.08236 0.04118,0.12354l0,0.12354c0,0.04118 -0.04118,0.08236 -0.04118,0.12354c-0.45296,0.78239 -1.68832,2.26482 -4.57082,1.85304a9.7552,9.7552 0 0 1 -1.48243,-0.37061z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    transform: "translate(0.04 0.04)",
    d: "m657.7039,323.5483a1.02946,1.02946 0 1 0 -1.02946,-1.02946a1.07476,1.07476 0 0 0 1.02946,1.02946z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m657.29211,322.43648a0.24707,0.24707 0 1 0 -0.24707,-0.24707a0.23884,0.23884 0 0 0 0.24707,0.24707z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    transform: "translate(0.04 0.04)",
    d: "m649.71525,323.5483a1.02946,1.02946 0 1 0 -1.02946,-1.02946a1.02123,1.02123 0 0 0 1.02946,1.02946z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(0.04 0.04)",
    d: "m649.26229,322.43648a0.24707,0.24707 0 1 0 -0.24707,-0.24707a0.26766,0.26766 0 0 0 0.24707,0.24707z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(0.04 0.04)",
    d: "m652.72129,327.17201a1.27242,1.27242 0 0 1 0.45296,-0.82357a1.20653,1.20653 0 0 1 0.90593,-0.28825c0.16471,0 0.24707,0.16471 0.24707,0.32943s-0.12354,0.24707 -0.32943,0.24707a0.52297,0.52297 0 0 0 -0.24707,0.04118a0.90181,0.90181 0 0 0 -0.20589,0.12354a0.41179,0.41179 0 0 0 -0.16471,0.20589c-0.04118,0.08236 -0.04118,0.16471 -0.08236,0.24707a0.52297,0.52297 0 0 0 0.04118,0.24707a0.90181,0.90181 0 0 0 0.12354,0.20589a0.41179,0.41179 0 0 0 0.20589,0.16471c0.08236,0.04118 0.16471,0.04118 0.24707,0.08236l1.35889,0.08236c0.16471,0 0.24707,0.16471 0.24707,0.32943s-0.16471,0.24707 -0.32943,0.24707l-1.35889,-0.08236a0.82357,0.82357 0 0 1 -0.45296,-0.12354a1.28065,1.28065 0 0 1 -0.37061,-0.28825a0.78651,0.78651 0 0 1 -0.20589,-0.41179a0.65062,0.65062 0 0 1 -0.08236,-0.53532z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    transform: "translate(0.04 0.04)",
    d: "m645.80329,321.36584l0,1.153a4.41434,4.41434 0 0 0 0.28825,1.60596a4.24963,4.24963 0 0 0 0.86475,1.35889a3.43429,3.43429 0 0 0 1.35889,0.90593a4.0808,4.0808 0 0 0 3.21193,0a4.90025,4.90025 0 0 0 1.35889,-0.90593a4.00667,4.00667 0 0 0 0.86475,-1.35889a4.2661,4.2661 0 0 0 0.28825,-1.60596l0,-1.153a1.43713,1.43713 0 0 0 -0.32943,-0.90593l1.60596,0a1.09535,1.09535 0 0 0 -0.24707,0.41179a2.05893,2.05893 0 0 0 -0.08236,0.49414l0,1.153a4.41434,4.41434 0 0 0 0.28825,1.60596a4.24963,4.24963 0 0 0 0.86475,1.35889a3.43429,3.43429 0 0 0 1.35889,0.90593a4.14256,4.14256 0 0 0 1.60596,0.32943a4.30728,4.30728 0 0 0 1.60596,-0.32943a4.90025,4.90025 0 0 0 1.35889,-0.90593a4.00667,4.00667 0 0 0 0.86475,-1.35889a4.2661,4.2661 0 0 0 0.28825,-1.60596l0,-1.153a1.54831,1.54831 0 0 0 -1.52361,-1.52361l-14.28896,0a1.33007,1.33007 0 0 0 -1.07064,0.41179a2.05893,2.05893 0 0 0 -0.32943,0.49414a0.75769,0.75769 0 0 0 -0.20589,0.61768zm10.58289,-0.98829l5.10614,0a0.98829,0.98829 0 0 1 0.94711,0.94711l0,1.153a3.45488,3.45488 0 0 1 -1.02946,2.47071a3.50018,3.50018 0 0 1 -5.97089,-2.47071l0,-1.153a1.13241,1.13241 0 0 1 0.32943,-0.61768a1.02123,1.02123 0 0 1 0.61768,-0.32943zm-10.12993,0.98829a1.05829,1.05829 0 0 1 0.28825,-0.65886a0.97181,0.97181 0 0 1 0.65886,-0.28825l5.14732,0a0.98829,0.98829 0 0 1 0.94711,0.94711l0,1.153a3.45488,3.45488 0 0 1 -1.02946,2.47071a3.50018,3.50018 0 0 1 -5.97089,-2.47071l-0.04118,-1.153z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    transform: "translate(0.04 0.04)",
    d: "m646.00918,316.46559c-5.31203,-0.41179 -11.24175,-9.18282 -3.41782,-14.57721c0,0 4.32375,-1.85304 4.32375,2.75896c3.62371,-6.58857 5.64146,1.40007 5.64146,1.40007s3.99432,-8.071 11.40646,-2.14129c3.37664,-4.0355 5.27086,0.41179 4.44728,1.97657c4.20021,-2.75896 8.27689,3.99432 4.98261,9.92403c-0.53532,0.94711 -0.78239,2.63543 -1.60596,2.42954c-2.51189,-0.61768 -3.50018,0.74121 -3.54136,2.96486c-0.04118,1.56479 -1.85304,1.40007 -1.81186,-0.12354c0,-1.60596 0.12354,-5.80618 -0.90593,-5.80618c-1.27654,0 -2.01775,2.51189 -3.37664,0.86475s1.89421,-3.54136 0,-4.85907c-1.85304,-1.153 -10.99468,5.60028 -16.142,5.1885z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fc9d9d",
    transform: "translate(0.04 0.04)",
    d: "m667.50439,323.30123c-0.45296,1.93539 -0.90593,3.41782 1.60596,3.21193c4.81789,-0.32943 5.35321,-6.79446 2.51189,-8.071c-2.47071,-1.11182 -3.29428,1.27654 -3.29428,1.27654l-0.82357,3.58253z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(0.04 0.04)",
    d: "m671.95168,321.44819c-0.08236,0.16471 -0.24707,0.16471 -0.45296,0.08236a0.98005,0.98005 0 0 0 -0.45296,-0.24707a1.00476,1.00476 0 0 0 -0.49414,0c-0.24707,0 -0.45296,0.24707 -0.65886,0.5765a3.1131,3.1131 0 0 0 -0.45296,1.44125l-0.08236,0.5765c0,0.16471 -0.16471,0.24707 -0.32943,0.24707s-0.24707,-0.16471 -0.24707,-0.32943l0.08236,-0.5765a4.76436,4.76436 0 0 1 0.49414,-1.81186a2.01363,2.01363 0 0 1 0.49414,-0.53532a1.8901,1.8901 0 0 1 0.65886,-0.28825a1.78715,1.78715 0 0 1 1.35889,0.32943c0.08236,0.08236 0.12354,0.24707 0.08236,0.53532z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    fill: "#231f20",
    transform: "translate(0.04 0.04)",
    d: "m629.04362,364.2739l1.31771,-5.02378c0.12354,-0.98829 1.89421,-0.90593 1.93539,0.12354l5.06496,68.72702l-4.94143,0l-3.37664,-63.82677z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(0.04 0.04)",
    d: "m517.24382,429.04777l-2.306,0l0,-16.84203l5.64146,0l-21.08342,-15.48314l-21.08342,15.44196l5.64146,0l0,16.84203l-2.306,0a2.43365,2.43365 0 0 0 -2.42954,2.42954l0,5.765l40.31381,0l0,-5.765a2.36365,2.36365 0 0 0 -2.38836,-2.38836zm-33.93113,-18.48917l16.18317,-11.85943l16.18317,11.85943l-32.36635,0zm30.01917,1.60596l0,16.84203l-4.24139,0l0,-16.84203l4.24139,0zm-5.84736,0l0,16.84203l-4.24139,0l0,-16.84203l4.24139,0zm-5.88853,0l0,16.84203l-4.24139,0l0,-16.84203l4.24139,0zm-5.84736,0l0,16.84203l-4.24139,0l0,-16.84203l4.24139,0zm-5.84736,0l0,16.84203l-4.24139,0l0,-16.84203l4.24139,0zm28.12496,23.47178l-37.10188,0l0,-4.15903a0.82357,0.82357 0 0 1 0.82357,-0.82357l35.49592,0a0.82357,0.82357 0 0 1 0.82357,0.82357l0,4.15903l-0.04118,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(0.04 0.04)",
    d: "m499.49586,402.44642a3.25311,3.25311 0 1 0 3.29428,3.25311a3.29428,3.29428 0 0 0 -3.29428,-3.25311zm0,4.94143a1.64714,1.64714 0 1 1 1.68832,-1.64714a1.68832,1.68832 0 0 1 -1.68832,1.64714z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbanCheck);
export default __webpack_public_path__ + "static/media/IbanCheck.35c193b049bf111c7c814eb63b168c7c.svg";
export { ForwardRef as ReactComponent };